module.exports = __webpack_public_path__ + "static/media/services.0299266d.jpg";